// Goldfish scooping at a summer festival, in toy space. Goldfish wander about
// an oval tub below the water surface, turning from its walls and darting
// away from a poi that comes near them under water. The poi is a paper disc:
// in the water it soaks, faster while it is swished about, and once soaked
// through it tears. Lifting it with a goldfish over the paper scoops the fish
// out and into the bowl, unless the wet paper gives way under its weight.
export class KingyoSukui{
  constructor({tub,poi,fish=5,bowl,random=Math.random}){
    this.tub=tub;this.poiR=poi;this.bowl=[...bowl];this.random=random;this.count=fish;this.reset();
  }
  reset(){
    const r=this.random,t=this.tub;
    this.fish=Array.from({length:this.count},(_,i)=>{const a=r()*Math.PI*2,d=Math.sqrt(r())*.7;
      return {p:[t.center[0]+Math.cos(a)*d*t.rx,t.floor+(t.surface-t.floor)*(.3+.4*r()),t.center[2]+Math.sin(a)*d*t.rz],heading:r()*Math.PI*2,speed:.25+.15*r(),size:.8+.4*r(),kind:i===0?'black':'red',state:'swim',turn:0,t:0};});
    this.newPoi();this.caught=0;
  }
  newPoi(){this.poi={p:[this.tub.center[0],this.tub.surface+.15,this.tub.center[2]],down:false,wet:0,torn:false,speed:0,last:null};}
  movePoi(xz){const p=this.poi;p.p[0]=xz[0];p.p[2]=xz[1];}
  press(){this.poi.down=true;this.poi.entered=this.clock??0;}
  // A squeeze on the soft tub at a point sends a wave across: fish near it dart away.
  wave(point,strength=1){
    const t=this.tub;let moved=0;
    for(const f of this.fish){
      if(f.state!=='swim')continue;const dx=f.p[0]-point[0],dz=f.p[2]-point[2],d=Math.hypot(dx,dz);
      if(d<t.rx*1.4){f.fled=Math.atan2(dz,dx);f.scare=.8*strength;moved++;}
    }
    return moved;
  }
  // Lifting: anything lying over the paper comes up with it, if it holds.
  release(){
    const p=this.poi,events=[];if(!p.down)return events;p.down=false;
    if(p.torn)return events;
    const on=this.fish.filter(f=>f.state==='swim'&&Math.hypot(f.p[0]-p.p[0],f.p[2]-p.p[2])<this.poiR*1.2&&f.p[1]>p.p[1]-.03);
    const load=on.reduce((s,f)=>s+f.size,0);
    // Soaked paper holds less: a heavy catch on wet paper tears through.
    if(on.length&&load*.25>1.15-p.wet){p.torn=true;events.push('tear');return events;}
    for(const f of on){f.state='flying';f.t=0;f.from=[...f.p];events.push('catch');this.caught++;}
    return events;
  }
  step(dt){
    const events=[],t=this.tub,p=this.poi,R=t.rx;this.clock=(this.clock??0)+dt;
    // The poi sinks below the surface while pressed.
    // Pressed, it slides down to about mid-depth, under the swimming fish.
    const target=p.down?t.surface-(t.surface-t.floor)*.6:t.surface+.15;p.p[1]+=(target-p.p[1])*Math.min(1,dt*14);
    const moved=p.last?Math.hypot(p.p[0]-p.last[0],p.p[2]-p.last[1])/Math.max(dt,1e-6):0;p.last=[p.p[0],p.p[2]];
    p.speed+=(moved-p.speed)*Math.min(1,dt*10);
    if(p.p[1]<t.surface&&!p.torn){
      p.wet=Math.min(1,p.wet+dt*(.17+.5*Math.min(2,p.speed/R)));
      if(p.wet>=1){p.torn=true;events.push('tear');}
    }
    for(const f of this.fish){
      if(f.state==='flying'){
        f.t+=dt/.9;const k=Math.min(1,f.t);for(let a=0;a<3;a++)f.p[a]=f.from[a]+(this.bowl[a]-f.from[a])*k+(a===1?Math.sin(Math.PI*k)*.5:0);
        if(k>=1){f.state='bowl';f.p=[this.bowl[0]+(this.random()-.5)*.1,this.bowl[1],this.bowl[2]+(this.random()-.5)*.1];}
        continue;
      }
      if(f.state!=='swim')continue;
      // Wander, with a little burst away from a poi coming near under water.
      f.turn+=(this.random()-.5)*dt*4;f.turn*=Math.exp(-dt*1.5);f.heading+=f.turn*dt*3;
      let speed=f.speed;
      // They dart from the splash as the poi goes in, or from a poi chasing them fast;
      // a poi held still is something to swim over.
      const splash=(this.clock-(p.entered??-9))<.3,chased=p.speed>R*.45;
      if(p.p[1]<t.surface&&(splash||chased)){const dx=f.p[0]-p.p[0],dz=f.p[2]-p.p[2],d=Math.hypot(dx,dz);if(d<this.poiR*(splash?1.4:2)&&d>1e-6){const away=Math.atan2(dz,dx),diff=Math.atan2(Math.sin(away-f.heading),Math.cos(away-f.heading));f.heading+=diff*Math.min(1,dt*6);speed*=2.2;}}
      // A wave from the tub wall pushes them off.
      if(f.scare>0){f.scare-=dt;const diff=Math.atan2(Math.sin(f.fled-f.heading),Math.cos(f.fled-f.heading));f.heading+=diff*Math.min(1,dt*8);speed*=2.6;}
      // Turn back from the wall.
      const ex=(f.p[0]-t.center[0])/t.rx,ez=(f.p[2]-t.center[2])/t.rz,e=Math.hypot(ex,ez);
      if(e>.62){const inward=Math.atan2(-ez*t.rx,-ex*t.rz),diff=Math.atan2(Math.sin(inward-f.heading),Math.cos(inward-f.heading));f.heading+=diff*Math.min(1,dt*4*(e-.62)/.16);}
      f.p[0]+=Math.cos(f.heading)*speed*R*.6*dt;f.p[2]+=Math.sin(f.heading)*speed*R*.6*dt;
      const k=Math.hypot((f.p[0]-t.center[0])/t.rx,(f.p[2]-t.center[2])/t.rz);
      // A fish is long: keep its centre well inside so nose and tail stay in the tub.
      if(k>.78){f.p[0]=t.center[0]+(f.p[0]-t.center[0])*.78/k;f.p[2]=t.center[2]+(f.p[2]-t.center[2])*.78/k;}
      f.p[1]+=(t.floor+(t.surface-t.floor)*.55-f.p[1])*dt*.3+Math.sin(this.random()*6)*.002;
      f.p[1]=Math.max(t.floor+.02,Math.min(t.surface-.04,f.p[1]));
    }
    return events;
  }
}
